import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import {
  IGetDetailEndYear,
  IGetDetailHolyWeek,
  IGetDetailHolyWeekRequest,
  IGetDetailJuneVacation,
} from '../../interfaces/detail-seasonal.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SeasonalDetailService {
  constructor(
    private appSetting: AppSettings,
    private httpClient: HttpClient
  ) {}

  /**
   * Helper method to add filters to HttpParams, properly handling arrays
   */
  private addFiltersToParams(params: HttpParams, filters: any): HttpParams {
    if (!filters) return params;

    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // Para arrays, agregar cada elemento como un parámetro separado
        value.forEach((item: any) => {
          if (item !== null && item !== undefined && item !== '') {
            params = params.append(key, item.toString());
          }
        });
      } else if (value !== null && value !== undefined && value !== '') {
        // Para valores únicos
        params = params.append(key, value.toString());
      }
    });

    return params;
  }

  getSeasonalDetailHolyWeek(
    data: IGetDetailHolyWeekRequest
  ): Observable<IGetDetailHolyWeek> {
    const url = `${this.appSetting.estacionalPrediction.urls.base}/holyweek/detail`;
    let params = new HttpParams()
      .set('fechaInicio', data.fechaInicio)
      .set('fechaFin', data.fechaFin)
      .set('baseCalculo', data.baseCalculo.toString());

    params = this.addFiltersToParams(params, data.filters);

    return this.httpClient.get<IGetDetailHolyWeek>(url, { params });
  }

  getSeasonalDetailRecessWeek(
    data: IGetDetailHolyWeekRequest
  ): Observable<IGetDetailHolyWeek> {
    const url = `${this.appSetting.estacionalPrediction.urls.base}/recessweek/detail`;
    let params = new HttpParams()
      .set('fechaInicio', data.fechaInicio)
      .set('fechaFin', data.fechaFin)
      .set('baseCalculo', data.baseCalculo.toString());

    params = this.addFiltersToParams(params, data.filters);

    return this.httpClient.get<IGetDetailHolyWeek>(url, { params });
  }

  getSeasonalDetailJuneVacations(
    data: IGetDetailHolyWeekRequest
  ): Observable<IGetDetailJuneVacation> {
    const url = `${this.appSetting.estacionalPrediction.urls.base}/vacation/detail`;
    let params = new HttpParams()
      .set('fechaInicio', data.fechaInicio)
      .set('fechaFin', data.fechaFin)
      .set('baseCalculo', data.baseCalculo.toString());

    params = this.addFiltersToParams(params, data.filters);

    return this.httpClient.get<IGetDetailJuneVacation>(url, { params });
  }

  getSeasonalDetailEndYear(
    data: IGetDetailHolyWeekRequest
  ): Observable<IGetDetailEndYear> {
    const url = `${this.appSetting.estacionalPrediction.urls.base}/endyear/detail`;
    let params = new HttpParams()
      .set('fechaInicio', data.fechaInicio)
      .set('fechaFin', data.fechaFin)
      .set('baseCalculo', data.baseCalculo.toString());

    params = this.addFiltersToParams(params, data.filters);

    return this.httpClient.get<IGetDetailEndYear>(url, { params });
  }
}
